// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RN3tt","newExpiryDate":"styles_newExpiryDate__3KY-B","footer":"styles_footer__6dnzw"};